import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactory, ComponentFactoryResolver, ComponentRef } from '@angular/core';
import { NodoEntity, DatoEntity, FiltrosFormatoAsistencialEntity, FormatoAsistencialEntity } from '../../../../services/servicio-formato-asistencial.service';
import { AcordionTabComponent } from './acordion-tab/acordion-tab.component';

@Component({
  selector: 'app-acordion',
  templateUrl: './acordion.component.html',
  styleUrls: ['./acordion.component.css']
})
export class AcordionComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() datos: DatoEntity[];

  @ViewChild('acordionContainer', { read : ViewContainerRef}) container: ViewContainerRef;

  titulo: string;
  items: number;

  constructor( private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    if (this.nodo) {
      this.onProcess();
    } else {
      this.titulo = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.items = 0;
    let index = -1;
    if (this.nodo.hijos && this.nodo.hijos.length > 0) {
      this.nodo.hijos = this.nodo.hijos.sort((a: NodoEntity, b: NodoEntity) => a.orden - b.orden);
      this.nodo.hijos.forEach((h: NodoEntity) => {
        this.items++;
        index++;
        this.getAcordionTab(h, index);
      });
    }
  }

  getAcordionTab(nodo: NodoEntity, index: number): ComponentRef<AcordionTabComponent> {
    const factory: ComponentFactory<AcordionTabComponent> = this.componentFactory.resolveComponentFactory(AcordionTabComponent);
    const component: ComponentRef<AcordionTabComponent> = this.container.createComponent(factory);
      component.instance.nodo = nodo;
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.onDelete = () => {
        this.onDetach(index, component);
      };
    return component;
  }

  onDetach(index: number, component: any) {
    const idx = this.container.indexOf(component);
    this.container.remove(idx);
    this.items--;
    if (this.items === 0) {
      setTimeout(() => {
        this.onDelete();
      }, 50);
    }
  }

  onDelete() { }

}
